import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssociationEntryNoteCoaService {

  private URL = environment.api + "api/erp/entry-note/coa/association";

  constructor(
    private http: HttpClient
  ) {}

  getAssociationsByEntryNote(entryNoteId: number) {
    return this.http.get(`${this.URL}/${entryNoteId}/entryNotes`);
  }

  getAssociationsByCoa(coaId: number) {
    return this.http.get(`${this.URL}/${coaId}/coa`);
  }

  createAssociation(entryNoteId: number, coaId: number) {
    let params = new HttpParams()
      .set('entryNoteId', entryNoteId)
      .set('coaId', coaId);

    return this.http.post(`${this.URL}/create`, null, { params });
  }


  deleteAssociation(companyId: number, entryNoteId?: number, coaId?: number) {
    let params = new HttpParams();
    if (entryNoteId) params = params.set('entryNoteId', entryNoteId);
    if (coaId) params = params.set('coaId', coaId);

    return this.http.delete(`${this.URL}/delete`, {params});
  }


}
